document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const toggleButton = document.querySelector('[data-toggle="filters"]')
    const sidebar = document.getElementById("cloud_search_filters_sidebar")
    const productContainer = document.querySelector("#MainContent div.page-collections")
    const toggleButtonMobile = document.querySelector(
      "a.cloud-search-page-controls__filters-link"
    )

    const filtersElement = document.querySelector("#cloud_search_filters_root")
    if (filtersElement && filtersElement.querySelector(".cloud-search-clear-filters")) {
      filtersElement.classList.add("has-clear-filters")
    }

    const appliedFilters = document.querySelector(".cloud-search-page-controls__applied-filters")

    if (toggleButton && sidebar) {
      toggleButton.addEventListener("click", () => {
        const isHidden = productContainer.classList.contains("filters-opened")
        !isHidden
          ? productContainer.classList.add("filters-opened")
          : productContainer.classList.remove("filters-opened")
        renameSortsInFilters()
      })
    }

    if (toggleButtonMobile) {
      toggleButtonMobile.addEventListener("click", () => {
        renameSortsInFilters()
      })
    }

    if (appliedFilters) document.querySelector("body").classList.add("search-results-page")

    renameSortsInFilters()
  }, 250)
})

function renameSortsInFilters() {
  const sortLabelsDesktop = document.querySelectorAll(
    '[data-filter-name="Sort by"] .cloud-search-filter-value'
  )

  const labelMap = {
    manual: "Relevance",
    "created-descending": "Newest",
    "best-selling": "Top sellers",
    "price-descending": "Price (High - Low)",
    "price-ascending": "Price (Low - High)",
  }

  sortLabelsDesktop.forEach(label => {
    const value = label.getAttribute("data-filter-value")
    if (labelMap[value]) {
      const nameSpan = label.querySelector(".cloud-search-filter-value__name")
      if (nameSpan) nameSpan.textContent = labelMap[value]
    } else {
      label.style.display = "none"
    }
  })
}

// Bind toggle button functionality
function bindToggleSizesButton() {
  const toggleButton = document.querySelector('[data-toggle="sizes"]')
  if (!toggleButton) return

  let sizesVisible = false

  toggleButton.addEventListener("click", () => {
    document.body.classList.toggle("sizes-visible", !sizesVisible)

    toggleButton.textContent = sizesVisible ? "Show sizes" : "Hide sizes"
    sizesVisible = !sizesVisible
  })
}

function highlightActiveFilters() {
  const urlParams = new URLSearchParams(window.location.search)

  document.querySelectorAll(".item[data-filter]").forEach(function (item) {
    const filter = item.getAttribute("data-filter")
    if (!filter) return

    const [paramKey, paramValue] = filter.split("=")
    const currentValue = urlParams.get(paramKey)
    const decodedParamValue = decodeURIComponent(paramValue.replace(/\+/g, " "))

    if (currentValue === decodedParamValue) {
      item.classList.add("selected")
    } else {
      item.classList.remove("selected")
    }
  })
}

document.addEventListener("DOMContentLoaded", function () {
  bindToggleSizesButton()
  highlightActiveFilters()
})

function applyFilter(filterParam) {
  const currentUrl = new URL(window.location.href)

  // If not on /a/search, redirect with preserved params
  if (!currentUrl.pathname.startsWith("/a/search")) {
    const parts = currentUrl.pathname.split("/")
    const collectionHandle = parts[2] || ""

    const [paramKey, paramValueRaw] = filterParam.split("=")

    // Clone existing query params (e.g., sort_by)
    const params = new URLSearchParams(currentUrl.search)

    // Add or update the filter
    params.set(paramKey, paramValueRaw)

    // Replace %2B with +
    const queryString = params.toString().replace(/%2B/g, "+")

    // Redirect to the new URL
    window.location.href = `/a/search/${collectionHandle}?${queryString}`
    return
  }

  // Already on /a/search – update or add the filter param
  const [paramKey, paramValueRaw] = filterParam.split("=")

  const params = new URLSearchParams(currentUrl.search)
  params.set(paramKey, paramValueRaw)

  const queryString = params.toString().replace(/%2B/g, "+")
  const newUrl = `${currentUrl.origin}${currentUrl.pathname}?${queryString}`
  window.location.href = newUrl
}

document.addEventListener("DOMContentLoaded", function () {
  const selectedItem = document.querySelector(".collection-filter li.item.selected[data-filter]")
  const activeStyle = selectedItem ? selectedItem.getAttribute("data-filter") : ""

  const allItems = document.querySelectorAll(".collection-filter li.item")

  allItems.forEach(item => {
    // If no filter is active, mark the default item (with data-style) as selected
    if (!activeStyle && item.hasAttribute("data-style")) {
      item.classList.add("selected")
    }
  })
})
